import { Navigate, useSearchParams } from "@solidjs/router";
import { onMount } from "solid-js";
import { removeAuthToken } from "@/api/client";
import { useAuthV2 } from "@/domains/auth/context/auth-provider";
import { clearFreelanceSearchStore } from "@/domains/company/active-search/store/freelance-search-store";
import { clearCompanyStore } from "@/domains/company/company/store/company-store";
import { clearAllCompanyOnboardingDrafts } from "@/domains/company/onboarding/store/draft-store";
import { usePostHog } from "@/hooks/usePostHog";
import { getSafeRedirectPath } from "@/libs/redirect";

const LogoutRoute = () => {
  const [, setAuth] = useAuthV2();
  const { reset } = usePostHog();
  const [searchParams] = useSearchParams();

  onMount(() => {
    setAuth({
      user: null,
      profile: null,
      companies: null,
      loading: false,
    });
    removeAuthToken();
    clearCompanyStore();
    clearFreelanceSearchStore();
    // Every user's key, not just the current one: the interceptor lands here
    // after a failed token refresh, with no user id left to scope by. On a
    // shared device privacy wins over the resume promise (PLAN D15).
    clearAllCompanyOnboardingDrafts();
    reset();
  });

  /**
   * Dove tornare dopo la pulizia.
   *
   * Il logout non è sempre una scelta: ci si arriva anche dall'interceptor,
   * quando un refresh token scaduto fa fallire il bootstrap. In quel caso la
   * pagina di partenza era spesso **pubblica** — un link profilo condiviso — e
   * atterrare sul login era un vicolo cieco per qualcosa che non richiedeva
   * affatto una sessione. Se il ritorno è a una rotta protetta, `ProtectedRoute`
   * rimbalza comunque su `/auth?next=…`: la destinazione si conserva invece di
   * perdersi.
   *
   * `getSafeRedirectPath` è lo stesso filtro del login: un `next` che punta
   * fuori dal sito diventa il fallback.
   */
  const destination = () =>
    getSafeRedirectPath(
      typeof searchParams.next === "string" ? searchParams.next : null,
      "/auth",
    );

  return <Navigate href={destination()} />;
};

export default LogoutRoute;
